// import { Link } from "react-router-dom"
import IIAU from "../assets/iiau.jpg"
import Setup from "../assets/setup.jpg"
import Leetcode from "../assets/lc-logo.jpg"
import Books from "../assets/books.jpg"

function Aboutme() {
    return (
        <div className="about container__blog general-margin_top">
            <h1 className="aboutme_title text-center mb-5">ABOUT ME</h1>
            <p className="blog-text mb-4">
                Hi there, I am Abbos Shamsiddinov, a learner person, currently living in Tashkent, capital city of Uzbekistan.
            </p>
            <p className="blog-text mb-3">
                I always wanted to be diplomat when I was young😃.So that, I applied a university named IIAU(International Islamic Academy of Uzbekistan) in 2020, and by getting 90 percent of score <b>(170.3/189)</b>, I was admitted to the university faculty of <b>Islamic finance and International relations</b>.
            </p>
            <img className="mb-5" src={IIAU} alt="iiau img" width={630} height={350} />

            <p className="blog-text">
                After studying some period of time in University I had changed my mind the whole.I came recognized that this field is not for me, because I am very keen on being free and thinking creative.For all of these reason I started learning IT and now I am happy for this.
            </p>

            <img className="mb-5" src={Setup} alt="setup img" width={630} height={350} />

            <p className="blog-text">I have some hobbies such as reading books, solving algorithms and playing chess.</p>

            <div className="d-flex flex-wrap mb-5">
                <img className="" src={Leetcode} alt="setup img" width={315} height={350} />
                <img className="" src={Books} alt="setup img" width={315} height={350} />
            </div>

            <p className="blog-text">It's all briefly about me🙂.</p>

            {/* <Link className="btn btn-outline-info back-btn" to="/"> ← Back </Link> */}
        </div>
    );
}

export default Aboutme;
